export class FeatureServiceItem {
    constructor({el, onHover, onLeave, index}) {
        this.DOM = {el}
        this.onHover = onHover;
        this.onLeave = onLeave;
        this.index = index;

        this.timeOutClear = null;

        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.bindEvent();
    }

    onMouseEnter() {

        this.DOM.el.classList.remove('is-out');
        this.DOM.el.classList.add('is-active');
        this.onHover(this.index);
    }

    onMouseLeave() {
        this.DOM.el.classList.remove('is-active');
        this.onLeave(this.index);
    }

    out() {
        this.DOM.el.classList.add('is-out');
    }

    clear(){
        this.DOM.el.classList.remove('is-out');
        this.DOM.el.classList.remove('is-active');
    }

    bindEvent() {
        this.DOM.el.addEventListener('mouseenter', this.onMouseEnter);
        this.DOM.el.addEventListener('mouseleave', this.onMouseLeave);
    }
}